module.exports = __webpack_public_path__ + "img/first-2-opened.57f8872d.webp";